import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import router from '../router/index'
import './assets/fonts/fonts.scss'
import './registerServiceWorker'
import { initMetrika, trackPageView } from './helpers/metrika'
import { updateSeo } from './helpers/seo'

const initApp = async () => {
  const app = createApp(App)
  const pinia = createPinia()

  // Регистрируем аналитику до запуска роутера, чтобы не потерять первый
  // просмотр у пользователя, который уже давал согласие ранее.
  initMetrika()
  router.afterEach((to, from) => {
    updateSeo(to)
    trackPageView(to, from)
  })

  app.use(pinia)
  app.use(router)

  // vue-tg обращается к глобальному Telegram во время импорта.
  if (window.Telegram?.WebApp) {
    const { VueTelegramPlugin } = await import('vue-tg')
    app.use(VueTelegramPlugin)
  }

  app.mount('#app')
}

initApp()
